// Roster profile status and document-status options and badge colours, shared by
// useProfiles and components that render them per row (DEV-738). Plain data so a
// component can import it without instantiating the useProfiles composable.

export const statusVariantMap = {
  created: 'secondary',
  pending: 'warning',
  action_required: 'warning',
  compliance: 'warning',
  enrolled: 'info',
  reassigned: 'info',
  completed: 'success',
  graduated: 'success',
  credited: 'success',
  not_graduated: 'danger',
  withdrew: 'danger',
  withdrew_s1: 'danger',
  withdrew_s2: 'danger',
  withdrew_s3: 'danger',
  withdrew_s3_bah: 'danger',
  terminated: 'danger',
  replaced: 'warning',
  leave_of_absence: 'warning',
  denial_of_benefit: 'dark',
  archived: 'dark',
};

export const resolveProfileStatusVariant = (status) => statusVariantMap[status] || 'info';

export const resolveProfileYNVariant = (status) => {
  if (status === 'yes' || status === true) return 'success';
  if (status === 'partial' || status === true) return 'info';
  if (status === 'no' || status === false) return 'danger';
  return 'warning';
};

export const statusOptions = [
  { label: 'Created', value: 'created' },
  { label: 'Pending', value: 'pending' },
  { label: 'Action Required', value: 'action_required' },
  { label: 'Compliance', value: 'compliance' },
  { label: 'Enrolled', value: 'enrolled' },
  { label: 'Withdrawal S1', value: 'withdrew_s1' },
  { label: 'Withdrawal S2', value: 'withdrew_s2' },
  { label: 'Withdrawal S3', value: 'withdrew_s3' },
  { label: 'Withdrew S3 - BAH', value: 'withdrew_s3_bah' },
  { label: 'Terminated', value: 'terminated' },
  { label: 'Graduated', value: 'graduated' },
  { label: 'DNG', value: 'not_graduated' },
  { label: 'Denial of Benefits', value: 'denial_of_benefit' },
  { label: 'Leave of Absence', value: 'leave_of_absence' },
  { label: 'Archived', value: 'archived' },
];

export const uploadedCoeOptions = [
  { label: 'N/A', value: 'na' },
  { label: 'No', value: 'no' },
  { label: 'Partial', value: 'partial' },
  { label: 'In Review', value: 'in_review' },
  { label: 'Yes', value: 'yes' },
];

export const uploadedResumeOptions = [
  { label: 'N/A', value: 'na' },
  { label: 'No', value: 'no' },
  { label: 'In Review', value: 'in_review' },
  { label: 'Yes', value: 'yes' },
];

export const uploadedTranscriptOptions = [
  { label: 'N/A', value: 'na' },
  { label: 'No', value: 'no' },
  { label: 'In Review', value: 'in_review' },
  { label: 'Yes', value: 'yes' },
];

export const resolveProfileLocationStatus = (status) => {
  if (status === 'virtual') return 'info';
  if (status === 'physical') return 'success';
  return 'info';
};

export const resolveProfileSectionStatusVariant = (status) => statusVariantMap[status] || 'info';

export const resolveProfileProgramVariant = (status) => {
  if (status === 'open') return 'success';
  if (status === 'vettec') return 'info';
  if (status === 'vettec2') return 'info';
  if (status === 'vrrap') return 'info';
  if (status === 'army_cool') return 'warning';
  if (status === 'wioa') return 'warning';
  return 'secondary';
};

export const sectionStatusOptions = [
  { label: 'Pending', value: 'pending' },
  { label: 'Enrolled', value: 'enrolled' },
  { label: 'Completed', value: 'completed' },
  { label: 'Graduated', value: 'graduated' },
  { label: 'DNG', value: 'not_graduated' },
  { label: 'Credited', value: 'credited' },
  { label: 'Reassigned', value: 'reassigned' },
  { label: 'Replaced', value: 'replaced' },
  { label: 'Withdrew', value: 'withdrew' },
  { label: 'Terminated', value: 'terminated' },
  { label: 'Leave of Absence', value: 'leave_of_absence' },
  { label: 'Denial of Benefit', value: 'denial_of_benefit' },
  { label: 'Archived', value: 'archived' },
];

export const fundingSourceOptions = [
  { label: 'Open', value: 'open' },
  { label: 'VRRAP', value: 'vrrap' },
  { label: 'VET-TEC', value: 'vettec' },
  { label: 'VETTEC 2.0', value: 'vettec2' },
  { label: 'WIOA', value: 'wioa' },
  { label: 'GI Bill', value: 'gi_bill' },
  { label: 'DARS / DBVI', value: 'dars_dbvi' },
  { label: 'Army COOL', value: 'army_cool' },
  { label: 'AirForce COOL', value: 'airforce_cool' },
  { label: 'MYCAA', value: 'mycaa' },
  { label: 'VR&E', value: 'vrne' },
  { label: 'Corporate', value: 'corp' },
  { label: 'Audit', value: 'audit' },
  { label: 'STEM', value: 'stem' },
];

export const examVoucherOptions = [
  { label: 'N/A', value: 'na' },
  { label: 'Pending', value: 'pending' },
  { label: 'No', value: 'no' },
  { label: 'Yes', value: 'yes' },
];

export const yesNoOptions = [
  { label: 'N/A', value: 'na' },
  { label: 'No', value: 'no' },
  { label: 'Yes', value: 'yes' },
];

export const yesNoActualOptions = [
  { label: 'No', value: 'no' },
  { label: 'Yes', value: 'yes' },
];

export const locationOptions = [
  { label: 'Virtual', value: 'virtual' },
  { label: 'Physical', value: 'physical' },
];

// DEV-753: segment-3 withdrawals (incl. BAH) and terminations may record a mitigating circumstance.
export const MITIGATING_STATUSES = ['withdrew_s3', 'withdrew_s3_bah', 'terminated'];

// Statuses that require a reason when set.
export const REASON_STATUSES = ['withdrew_s1', 'withdrew_s2', 'withdrew_s3', 'withdrew_s3_bah', 'terminated'];

export const mitigatingCircumstanceOptions = [
  { label: 'Illness or death in immediate family', value: 'family_illness_or_death' },
  { label: 'Injury/illness while enrolled', value: 'illness_while_enrolled' },
  { label: 'Change in employment conditions', value: 'employment_change' },
  { label: 'Job transfer to a new location (in person only)', value: 'job_transfer' },
  { label: 'Immediate family or financial demands', value: 'family_or_financial_demands' },
  { label: 'Active military service', value: 'active_military_service' },
  { label: 'Program cancellation', value: 'program_cancellation' },
  { label: 'Child care coverage cancellation', value: 'child_care_cancellation' },
];

export const reEnrollmentEligibilityOptions = [
  { label: 'No', value: 'no', marker: 'danger' },
  { label: 'With COE documentation', value: 'coe_documentation', marker: 'warning' },
  { label: 'Yes, with appeal', value: 'appeal', marker: 'warning' },
  { label: 'Yes with documentation', value: 'documentation', marker: 'warning' },
  { label: 'Yes', value: 'yes', marker: null },
];

export const isMitigatingStatus = (status) => MITIGATING_STATUSES.includes(status);

export const resolveMitigatingCircumstanceLabel = (value) => {
  const option = mitigatingCircumstanceOptions.find((o) => o.value === value);
  return option ? option.label : null;
};

export const resolveReEnrollmentLabel = (value) => {
  const option = reEnrollmentEligibilityOptions.find((o) => o.value === value);
  return option ? option.label : null;
};

// Student-level re-enrollment eligibility marker: 'danger' | 'warning' | null (none for 'yes' or unset).
export const resolveReEnrollmentMarker = (value) => {
  const option = reEnrollmentEligibilityOptions.find((o) => o.value === value);
  return option ? option.marker : null;
};
